import { useCallback } from "react";

import { StartedDialogue } from "@/features/socratic/types";
import { useStartSocraticDialogueMutation } from "@/generated/graphql";

export const useStartDialogue = () => {
  const [mutation, { loading, data, error }] =
    useStartSocraticDialogueMutation();

  const startDialogue = useCallback(
    ({ workId, dialogueId }: { workId: string; dialogueId: string }) => {
      return mutation({
        variables: {
          workId,
          dialogueId,
        },
      });
    },
    [mutation]
  );

  const startedDialogue: StartedDialogue | null =
    data?.startSocraticDialogue.dialogue?.startedAt != null
      ? (data.startSocraticDialogue.dialogue as StartedDialogue)
      : null;

  const startError = data?.startSocraticDialogue.error ?? null;

  return {
    startDialogue,
    startedDialogue,
    isStartingDialogue: loading,
    /** The payload's own error. `OUTSIDE_REATTEMPT_WINDOW` is the only live one. */
    startError,
    /** A transport or GraphQL failure, as opposed to a rejected request. */
    apolloError: error,
  };
};
